import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a49b2b30"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "overview" }
const _hoisted_2 = {
  key: 0,
  class: "subscription-wrapper"
}
const _hoisted_3 = { class: "plan-actions" }
const _hoisted_4 = { class: "subscription" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "warning", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Handlung erforderlich", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Das Abonnement wurde erstellt, die erste Zahlung konnte aber noch nicht ausgeführt werden. Es ist eine 3D-Secure Verifizierung für deine Kredit- oder Debitkarte notwendig. Klicke auf den Button unter diesem Text um diese Verifizierung jetzt vorzunehmen. Andernfalls werden wir dein Abonnement innerhalb der nächsten 24 Stunden stornieren. ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "warning", -1))
const _hoisted_9 = {
  key: 0,
  class: "method"
}
const _hoisted_10 = { class: "logo-last4-wrapper" }
const _hoisted_11 = { class: "text" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 2,
  class: "sum"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Zwischensumme", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "Umsatzsteuer (19 %)", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, [
  /*#__PURE__*/_createElementVNode("b", null, "Gesamtsumme")
], -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "estimate-info" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "material-icons-round" }, "info"),
  /*#__PURE__*/_createTextVNode(" Die Daten werden täglich zwischen 01:00 bis 03:00 Uhr aktualisiert. ")
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_button = _resolveComponent("md-button")!
  const _component_plan = _resolveComponent("plan")!
  const _component_plan_loader = _resolveComponent("plan-loader")!
  const _component_md_card = _resolveComponent("md-card")!
  const _component_md_table_column = _resolveComponent("md-table-column")!
  const _component_md_table = _resolveComponent("md-table")!
  const _component_billing_subscription_method_loader = _resolveComponent("billing-subscription-method-loader")!
  const _component_billing_sum_loader = _resolveComponent("billing-sum-loader")!
  const _component_empty_hint = _resolveComponent("empty-hint")!
  const _component_billing_change_subscription_overlay = _resolveComponent("billing-change-subscription-overlay")!
  const _component_md_overlay = _resolveComponent("md-overlay")!
  const _component_billing_cancel_subscription_modal = _resolveComponent("billing-cancel-subscription-modal")!
  const _component_billing_reactivate_subscription_modal = _resolveComponent("billing-reactivate-subscription-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.subscription || _ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_ctx.subscription.plan)
            ? (_openBlock(), _createBlock(_component_plan, {
                key: 0,
                "plan-name": _ctx.subscription.plan
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_md_button, {
                      variant: "filled",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.changeOverlayVisible = true))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Abonnement ändern")
                      ]),
                      _: 1
                    }),
                    (_ctx.subscription && !_ctx.subscription.cancel_at)
                      ? (_openBlock(), _createBlock(_component_md_button, {
                          key: 0,
                          class: "cancel",
                          variant: "text",
                          grey: "",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs.cancelModal.open()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Abonnement beenden")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.subscription && _ctx.subscription.cancel_at)
                      ? (_openBlock(), _createBlock(_component_md_button, {
                          key: 1,
                          class: "cancel",
                          variant: "text",
                          grey: "",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$refs.reactivateModal.open()))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Kündigung zurücknehmen")
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["plan-name"]))
            : (_openBlock(), _createBlock(_component_plan_loader, { key: 1 })),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.subscription && _ctx.subscription.issue)
              ? (_openBlock(), _createBlock(_component_md_card, {
                  key: 0,
                  class: "alert"
                }, {
                  default: _withCtx(() => [
                    _hoisted_5,
                    _createElementVNode("div", null, [
                      _hoisted_6,
                      _hoisted_7,
                      _createVNode(_component_md_button, {
                        variant: "filled",
                        mode: "delete",
                        onClick: _ctx.verifyCard
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Verifizierung durchführen")
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.subscription && _ctx.subscription.cancel_at)
              ? (_openBlock(), _createBlock(_component_md_card, {
                  key: 1,
                  class: "alert canceled-alert"
                }, {
                  default: _withCtx(() => [
                    _hoisted_8,
                    _createElementVNode("p", null, " Das Abonnement wurde gekündigt und endet am " + _toDisplayString(_ctx.getDate(new Date(_ctx.subscription.cancel_at))) + ". ", 1),
                    _createVNode(_component_md_button, {
                      variant: "filled",
                      mode: "delete",
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$refs.reactivateModal.open()))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Kündigung aufheben")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            ((_ctx.rows && _ctx.rows.length > 0) || !_ctx.estimate)
              ? (_openBlock(), _createBlock(_component_md_table, {
                  key: 2,
                  rows: _ctx.rows,
                  "skeleton-rows": 3
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_md_table_column, {
                      title: "Pos.",
                      display: "index"
                    }),
                    _createVNode(_component_md_table_column, {
                      title: "Beschreibung",
                      display: "description"
                    }),
                    _createVNode(_component_md_table_column, {
                      title: "Zeitraum",
                      display: "period"
                    }),
                    _createVNode(_component_md_table_column, {
                      title: "Menge",
                      display: "amount",
                      numeric: true
                    }),
                    _createVNode(_component_md_table_column, {
                      title: "Preis",
                      display: "price",
                      numeric: true
                    })
                  ]),
                  _: 1
                }, 8, ["rows"]))
              : _createCommentVNode("", true),
            _createVNode(_component_md_card, {
              variant: "filled",
              class: "total"
            }, {
              default: _withCtx(() => [
                (_ctx.method)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        (_ctx.getLogo(_ctx.method.card?.brand))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "logo",
                              style: _normalizeStyle({
                  backgroundImage:
                    'url(' + _ctx.getLogo(_ctx.method.card?.brand || 'sepa') + ')',
                })
                            }, null, 4))
                          : _createCommentVNode("", true),
                        _createElementVNode("h3", null, "**** " + _toDisplayString(_ctx.method.card?.last4 || _ctx.method.sepa?.last4), 1)
                      ]),
                      _createElementVNode("h4", null, _toDisplayString(_ctx.method.holderName), 1),
                      _createVNode(_component_md_button, { variant: "text" }, {
                        default: _withCtx(() => [
                          _createTextVNode("Zahlungsmethode ändern")
                        ]),
                        _: 1
                      })
                    ]))
                  : (_openBlock(), _createBlock(_component_billing_subscription_method_loader, { key: 1 })),
                _createElementVNode("div", _hoisted_11, [
                  (_ctx.estimate)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Nächste Rechnung am " + _toDisplayString(_ctx.getDate(new Date(_ctx.estimate.next_payment))) + ". Wir werden deine Zahlungsmethode automatisch belasten. Der angezeigte Betrag ist spiegelt die aktuelle Nutzung wider und kann sich bis zum Tag der Abrechnung ändern.", 1))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.estimate)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("table", null, [
                        _createElementVNode("tr", null, [
                          _hoisted_14,
                          _createElementVNode("td", null, _toDisplayString(_ctx.getPrice(_ctx.estimate.subtotal - (_ctx.estimate.discount || 0))) + " € ", 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_15,
                          _createElementVNode("td", null, _toDisplayString(_ctx.getPrice(_ctx.estimate.tax)) + " €", 1)
                        ]),
                        _createElementVNode("tr", null, [
                          _hoisted_16,
                          _createElementVNode("td", null, [
                            _createElementVNode("b", null, _toDisplayString(_ctx.getPrice(_ctx.estimate.total)) + " €", 1)
                          ])
                        ])
                      ])
                    ]))
                  : (_openBlock(), _createBlock(_component_billing_sum_loader, { key: 3 }))
              ]),
              _: 1
            }),
            _hoisted_17
          ])
        ]))
      : (_openBlock(), _createBlock(_component_empty_hint, {
          key: 1,
          title: "Noch kein Abonnement hinzufügt",
          description: "Füge ein Abonnement hinzu, um weitere Funktionen für deine Chatbots und deine Organisation freizuschalten."
        }, {
          default: _withCtx(() => [
            _createVNode(_component_md_button, {
              variant: "filled",
              icon: "add_circle",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeOverlayVisible = true))
            }, {
              default: _withCtx(() => [
                _createTextVNode("Abonnement hinzufügen")
              ]),
              _: 1
            })
          ]),
          _: 1
        })),
    _createVNode(_component_md_overlay, {
      title: "Abonnement ändern",
      visible: _ctx.changeOverlayVisible,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.changeOverlayVisible) = $event)),
      loading: _ctx.changeSubscriptionLoading,
      large: true
    }, {
      default: _withCtx(() => [
        _createVNode(_component_billing_change_subscription_overlay, {
          subscription: _ctx.subscription,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeOverlayVisible = false)),
          onLoading: _cache[6] || (_cache[6] = ($event: any) => (_ctx.changeSubscriptionLoading = $event))
        }, null, 8, ["subscription"])
      ]),
      _: 1
    }, 8, ["visible", "loading"]),
    _createVNode(_component_billing_cancel_subscription_modal, {
      ref: "cancelModal",
      subscription: _ctx.subscription
    }, null, 8, ["subscription"]),
    _createVNode(_component_billing_reactivate_subscription_modal, {
      ref: "reactivateModal",
      subscription: _ctx.subscription
    }, null, 8, ["subscription"])
  ]))
}